export default __webpack_public_path__ + "static/erziehungsziele-geburtstag-6f53a1d8c9902a4650f1d909c5aa3390.jpg";